











































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component

export default class ComponentAlert extends Vue {
  @Prop(String) action
  @Prop(Array || Object) buttons
  @Prop(String) icon
  @Prop(String) iconColor
  @Prop(String) subtitle
  @Prop(String) title

  @Emit('method')
  method() {}
}
